import { HttpClient, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
// import * as Access from '@app/models/access';
import * as Search from '@app/models/search';

@Injectable({
    providedIn: 'root'
})
export class DashboardRequests {
    constructor(private http: HttpClient, private urlSrv : UrlService) {}

    workflows$ = () : Observable<Objects.Workflow[]> =>
        this.http.get<Objects.Workflow[]>(this.urlSrv.build("/workflows"));

    workflowsCounter$ = (query:string, search:string) : Observable<Objects.WorkflowRequestsCounter[]> => {

        // set query_params to not have empty values ;
        const query_params = query && search ? { q: query, term: search } :
            query ? { q: query } :
            search ? { term: search } :
            {};

        if (Object.keys(query_params).length === 0) {
            // Both query and search are empty, return an empty observable with proper value.
            return of(null); // Or any other suitable value
        }
        return this.http.get<Objects.WorkflowRequestsCounter[]>(this.urlSrv.build("/projects/workflows/counters"), {params: query_params});
    }

    filterStatus$ = (workflow: Objects.Workflow) : Observable<Objects.Status[]> =>
        this.http.get<Objects.Status[]>(this.urlSrv.build("/requests/status"), {params: {workflow: workflow.id.toString()}});

    filterLabels$ = () : Observable<Objects.Label[]> =>
        this.http.get<Objects.Label[]>(this.urlSrv.build("/labels"));
    
    filterUsers$ = () : Observable<Objects.User[]> =>
        this.http.get<Objects.User[]>(this.urlSrv.build("/users"));

    results$ = (params: Search.SearchQueryParams, page: number, limit: number, workflow: number | string, rid: string | number | null) : Observable<Objects.ExtendedRequest[]> => {
        let query = {...params, page: page.toString(), limit: limit.toString(), workflow: workflow.toString()};
        if(rid != null) {
            query['q'] = query.hasOwnProperty('q')? query['q'] + "+id:" + rid.toString() : "id:" + rid.toString();
            query['page'] = "1";
        }
        
        let p = new HttpParams();

        Object.keys(query).forEach(key => p = p.set(key, query[key]) );

        return this.http.get<Objects.ExtendedRequest[]>(this.urlSrv.build("/requests"), { params: p});
    }

    setprojectStatus$ =  (id: number | string, status: Objects.Status) =>
        this.http.put<Objects.ExtendedRequest>(this.urlSrv.build("/requests/"+id ), {status: status.id}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

}